import { SearchTargetDTO } from 'business/models/Models';
import { useDispatch } from 'react-redux';
import { useRMSelector } from 'redux/hooks';
import { setResultCount } from 'redux/reducers/imageManagementTaskReducer';

export const useImageManagementTaskIsDirty = () => {
  return useRMSelector((state) => state?.imageManagementTask?.isDirty);
};

export const useImageManagementTasks = () => {
  return useRMSelector((state) => state?.imageManagementTask?.imageManagementTaskList);
};

export const useOriginalImageManagementTasks = () => {
  return useRMSelector(
    (state) => state?.imageManagementTask?.imageManagementTaskOriginalList,
  );
};

export const useIsImageManagementTaskListLoading = () => {
  return useRMSelector(
    (state) => state?.imageManagementTask?.isImageManagementTaskListLoading,
  );
};

export const useSelectedImageTaskId = () => {
  return useRMSelector((state) => state?.imageManagementTask?.selectedImageTaskId);
};
export const useSelectedImageManagementTask = () => {
  return useRMSelector((state) =>
    state?.imageManagementTask?.imageManagementTaskList.find(
      (q) => q.id === state?.imageManagementTask?.selectedImageTaskId,
    ),
  );
};

export const useSelectedImageActionId = () => {
  return useRMSelector((state) => state?.imageManagementTask?.selectedImageActionId);
};

export const useDeletedImageActionIds = () => {
  return useRMSelector((state) => state?.imageManagementTask?.deletedActionIds);
};

export const useImageManagementTasksResults = () => {
  return useRMSelector(
    (state) => state?.imageManagementTask?.imageManagementTaskResultList,
  );
};

export const useImageManagementTasksResultEmpty = () => {
  return useRMSelector((state) => state?.imageManagementTask?.isResultEmpty);
};

export const useSearchTargetsOldVersion = (): SearchTargetDTO[] => {
  return useRMSelector((state) => state.searchnFilter.searchTargetsOld.data);
};

export const useSearchTargetRelationsOld = (): { [key: string]: SearchTargetDTO[] } => {
  return useRMSelector((state) => state.searchnFilter.targetRelationsOld.data);
};

export const useCheckedExplorerNodes = () => {
  return useRMSelector((state) => state.imageManagementTask.checkedExplorerNodes);
};

export const useIsProcessedChecked = () => {
  return useRMSelector((state) => state?.imageManagementTask?.isProcessedChecked);
};

export const useIsPendingChecked = () => {
  return useRMSelector((state) => state?.imageManagementTask?.isPendingChecked);
};

export const useIsErrorChecked = () => {
  return useRMSelector((state) => state?.imageManagementTask?.isErrorChecked);
};

export const useResultCount = () => {
  return useRMSelector((state) => state?.imageManagementTask.resultCount);
};

export const useSetResultCount = () => {
  const dispatch = useDispatch();
  return (resultCount: number) => dispatch(setResultCount(resultCount));
};

export const useIsSelectedTaskRunning = () => {
  return useRMSelector((state) => state?.imageManagementTask.isRunning);
};

export const useIsSelectedTaskPreview = () => {
  return useRMSelector((state) => state?.imageManagementTask.isPreview);
};

export const useIsSelectedTaskError = () => {
  return useRMSelector((state) => state?.imageManagementTask.isError);
};

export const useDisplayResults = () => {
  return useRMSelector((state) => state?.imageManagementTask?.displayResults);
};

export const useResultTabProgress = () => {
  return useRMSelector((state) => state?.imageManagementTask?.progress);
};
